module.exports = __webpack_public_path__ + "distribution-of-total-plaque-by-age-female.112c398eba641cc9078a2ed4a0b0793a.png";